site.spjallmenni = site.spjallmenni || {};

site.spjallmenni = {
	init: function () {
		$(document).ready(function () {
		// Create and load the script
		const script = document.createElement('script');
		script.src = " https://chatbot-api.menni.ai/api/widget?secretKey=sk_9a53603e4db65d7e923973d902e4d539324153a10cf9ae62f9ab6eedc456ff87&position=bottom-right";
		script.async = true;

		// Add load event handler
		script.onload = function() {
			console.log('Chatbot widget loaded successfully');
		};

		// Add error event handler
		script.onerror = function(error) {
			console.error('Failed to load chatbot widget', error);
		};

		// Append the script to the document
		document.body.appendChild(script);
		});
	},
};

